import { useContext, createContext } from "react";

export const BackendLayoutContext = createContext({
    isAnimating: false,
});

export const useBackendLayoutContext = () => {
    return useContext(BackendLayoutContext);
};

export default useBackendLayoutContext;